(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/single-rows/single-boards.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/single-rows/single-boards.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.SingleRowBoards = Backbone.Collection.extend({
    log: new svs.core.log.Logger('svs.collections.SingleRowBoards'),
    model: svs.tipset.models.SingleBoard,

    initialize: function() {
      this.listenTo(svs.tipset.models.play, 'changeSingleRows', this.addModels);
      this.listenTo(
        svs.tipset.models.xpertenSystemsSingleRow,
        'add sync reset',
        this.setXpertBoardData
      );
      this.listenTo(
        svs.tipset.models.xpertenSystemsSingleRow,
        'generateSystem',
        this.clearXpertMarks
      );
      this.on('boardDataChanged', this.save);
    },

    addModels: function() {
      var boards = svs.utils.ns.isNamespace(
        'svs.tipset.objects.localstorageHandler.dataFromLocalStorage.boardData'
      )
          ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage
            .boardData
          : undefined,
        baseRow = svs.utils.ns.isNamespace(
          'svs.tipset.objects.localstorageHandler.dataFromLocalStorage.baseRow'
        )
          ? svs.tipset.objects.localstorageHandler.dataFromLocalStorage.baseRow
          : this.createEmptyBoardData(),
        self = this,
        boardData = [];

      for (var i = 0; i < svs.tipset.constants.NUMBER_OF_SINGLEROWS; i++) {
        boardData =
          boards && boards[i]
            ? svs.tipset.utils.convertBoardFromITSData(boards[i])
            : this.createEmptyBoardData();
        var newBoard = new svs.tipset.models.SingleBoard({
          boardData: boardData,
          boardId: i,
          baseRow: baseRow
        });
        self.add(newBoard);
      }
      this.trigger('allBoardsUpdated');
    },

    createEmptyBoardData: function() {
      var tmpBoard = [];
      for (
        var i = 0;
        i < svs.tipset.models.gameDefinitions.get('numberOfMatches');
        i++
      ) {
        tmpBoard.push(0);
      }

      return tmpBoard;
    },

    getActiveBoards: function() {
      return this.where({ hasMarkedItems: true });
    },

    getNrOfRows: function() {
      return this.where({ isCompleteBoard: true }).length;
    },

    getCompleteBoardsData: function() {
      return this.where({ isCompleteBoard: true });
    },

    isAnySet: function() {
      return this.where({ hasMarkedItems: true }).length > 0;
    },

    setXpertBoardData: function() {
      var boardData = [],
        boards = svs.tipset.models.xpertenSystemsSingleRow.getXpertBoardData();
      for (var i = 0; i < svs.tipset.constants.NUMBER_OF_SINGLEROWS; i++) {
        boardData = boards[i]
          ? svs.tipset.utils.convertBoardFromITSData(boards[i].boardData)
          : this.createEmptyBoardData();
        this.at(i).setCompleteBoardData(
          boardData,
          !svs.tipset.models.xpertenSystemsSingleRow.getUseBoardRow()
        );
      }
      this.trigger('xpertBoardDataIsSet');
    },

    clearAll: function() {
      var options = {
        isSilent: true
      };
      this.each(function(board) {
        board.clearBoardData(options);
      });
      this.save();
      this.trigger('allBoardsUpdated');
    },

    isPayable: function() {
      return this.where({ isCompleteBoard: true }).length > 0;
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    },
    getBaseRow: function() {
      var baseRow =
        this.getHasMarksSetByUser() && this.at(0).get('baseRow')
          ? this.at(0).get('baseRow')
          : undefined;
      return baseRow;
    },
    getHasMarksSetByUser: function() {
      return this.at(0) && this.at(0).getHasMarksSetByUser();
    },

    clearXpertMarks: function() {
      if (this.getHasMarksSetByUser()) {
        this.each(function(board) {
          board.removeXpertMarks();
        });
      } else {
        this.clearAll();
      }
    }
  });
})(Backbone, _, svs);

 })(window);